import React from 'react'
import parse from 'html-react-parser'
import * as E from '../../elementor'
import SmoothScrollLink from '../transition/smooth-scroll-link'

const SecondarySmallCTA = ({ section, color, solidDark }) => {
  const { heading, textEditor, button } = E.collect(section)
  const isScrollLink1 = button[0]?.link !== undefined && button[0]?.link.includes('#')
  const isScrollLink2 = button[1]?.link !== undefined && button[1]?.link.includes('#')

  const button1 = 
    <button>{button[0]?.text}
      <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g id='arrow-narrow-right' clip-path='url(#clip0_3710_5260)'>
          <path id='Icon' d='M0.1875 10H13.5208M13.5208 10L8.52083 5M13.5208 10L8.52083 15' stroke='currentColor' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
        </g>
        <defs>
          <clipPath id='clip0_3710_5260'>
            <rect width='20' height='20' fill='currentColor' transform='translate(0.666992)' />
          </clipPath>
        </defs>
      </svg>
    </button>

    const button2 = 
      <button>{button[1]?.text}
        <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g id='arrow-narrow-right' clip-path='url(#clip0_3710_5260)'>
            <path id='Icon' d='M0.1875 10H13.5208M13.5208 10L8.52083 5M13.5208 10L8.52083 15' stroke='currentColor' stroke-width='1.66667' stroke-linecap='round' stroke-linejoin='round' />
          </g>
          <defs>
            <clipPath id='clip0_3710_5260'>
              <rect width='20' height='20' fill='currentColor' transform='translate(0.666992)' />
            </clipPath>
          </defs>
        </svg>
      </button>

  return (
    <section>
      <div className='secondary-small-cta-wrapper' data-color={color} data-solid-dark={solidDark}>
        <div className='left box'>
          <h3>{parse(heading[0]?.title || '')}</h3>
          <p className='large'>{parse(textEditor[0]?.text() || '')}</p>
          {button[0] && button[0].link ?
            isScrollLink1 ? 
            <SmoothScrollLink className='small-cta-link' offset={0} link_id={button[0].button_css_id || ''} offsetMobile={0} id={button[0].link as string}>{button1}</SmoothScrollLink> :
            <a className='small-cta-link' href={button[0]?.link} id={button[0]?.button_css_id || ''}>{button1}</a>
          : null}
        </div>
        <div className='middle-line' data-color={color} data-solid-dark={solidDark} />
        <div className='right box'>
          <h3>{parse(heading[1]?.title || '')}</h3>
          <p className='large'>{parse(textEditor[1]?.text() || '')}</p>
          {button[1] && button[1].link ?
            isScrollLink2 ? 
            <SmoothScrollLink className='small-cta-link' offset={0} link_id={button[1].button_css_id || ''} offsetMobile={0} id={button[1]?.link as string}>{button2}</SmoothScrollLink>:
            <a className='small-cta-link' href={button[1]?.link}  id={button[1]?.button_css_id || ''}>{button2}</a>
          : null}
        </div>
      </div>
    </section>
  )
}

export default SecondarySmallCTA
